<style lang="scss" scoped>
@import url("./dashboard.scss");
</style>

<template>
  <div>
    <h1 class="title">{{ $t("workspace.dashboard") }}</h1>

    <div class="d-flex justify-content-between">
      <div class="d-flex mb-4" style="gap: 20px; flex-wrap: wrap;">
        <workspace-member-card />
        <workspace-organization-card />
      </div>
    </div>
  </div>
</template>

<script>
import WorkspaceMemberCard from "./components/workspace-member-card.vue";
import WorkspaceOrganizationCard from "./components/workspace-organization-card.vue";
export default {
  components: { WorkspaceMemberCard, WorkspaceOrganizationCard },
  data() {
    return {};
  },
  mounted() {
    this.showRightSideBar();
  },
  methods: {
    showRightSideBar() {
      //this.$store.dispatch("layout/SHOW_RIGHT_SIDEBAR");
    },
  },
};
</script>
